import { useAppDispatch } from '../../redux/app/hooks';
import { setBuckets } from '../../redux/features/buckets/BucketsSlice';
import { BucketItem, BucketType } from '../../redux/features/buckets/BucketsState';
import { IBucket, IBucketSource } from '../services/AuthoritiveService';
import { IResult, useAuthoritive } from './useAuthoritive';

export const useBucket = () => {
    const dispatch = useAppDispatch();
    const authoritiveService = useAuthoritive();

    const mapBuckets = (buckets: IBucket[]): BucketItem[] => {
        return buckets.map(
            (b) =>
                ({
                    id: b.Id,
                    title: b.Title,
                    color: b.Color,
                    type: BucketType.Bucket,
                }) as BucketItem,
        );
    };

    const mapBucketSources = (buckets: BucketItem[], sources: IBucketSource[]): BucketItem[] => {
        return sources.map(
            (s) =>
                ({
                    id: s.DocumentId,
                    title: s.Title,
                    type: BucketType.BucketSource,
                    url: s.DocumentUrl,
                    parent: buckets.find((b) => b.id === s.BucketId),
                }) as BucketItem,
        );
    };

    const getBuckets = async (user: string) => {
        const bucketsResponse: IResult<IBucket[]> = await authoritiveService.getBuckets(user);
        const bucketSourcesResponse: IResult<IBucketSource[]> = await authoritiveService.getBucketSources(user);

        if (bucketsResponse.Success && bucketSourcesResponse.Success) {
            const buckets = bucketsResponse.Data;
            const bucketSources = bucketSourcesResponse.Data;
            const filteredBuckets = buckets?.filter((b) => bucketSources?.some((i) => i.BucketId === b.Id));
            const bucketList: BucketItem[] = [];

            if (filteredBuckets?.length) {
                const mappedBuckets = mapBuckets(filteredBuckets);
                bucketList.push(...mappedBuckets);
                if (bucketSources?.length) {
                    const mappedBucketSources = mapBucketSources(mappedBuckets, bucketSources);
                    bucketList.push(...mappedBucketSources);
                }
            }

            dispatch(setBuckets(bucketList));
        }
    };

    return {
        getBuckets,
    };
};
